import React, { useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { useNavigate, Link } from 'react-router-dom'
import { Table } from "antd";
// import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import * as Yup from 'yup';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
// import { adminMainUrl } from '../../../../Config';
const AddMaster = ({ show, handleClose, onSuccess }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const closeButtonRef = useRef(null);
    const validationSchema = Yup.object({
        name: Yup.string().required('Name is required'),
        code: Yup.string().required('Code is required'),
        short_name: Yup.string().required('Short Name is required'),
        applicabl_for: Yup.string().required('Applicable for is required'),
        charge_category: Yup.string().required('Charge Category is required'),
        IATA_code: Yup.string().required('IATA Code is required'),
        // name: Yup.string().required('Code is required'),
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            name: '', // Initial value for the RequiredService type
            code: '',
            short_name: '',
            applicabl_for: '',
            charge_category: '',
            IATA_code: '',
            name: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            handleClose()
            formik.resetForm();
            setIsSubmitting(true);
            // try {
            //     const response = await fetch(`${adminMainUrl}/api/department/create`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
            //         },
            //         body: JSON.stringify(values),
            //     });

            //     const data = await response.json();

            //     if (response.ok) {
            //         // closeButtonRef.current.click();
            //         if (onSuccess) onSuccess();
            //         toast.success(data?.msg);
            //         handleClose()
            //         formik.resetForm();
            //     } else {
            //         toast.error(data?.msg);
            //         // Handle errors from the server
            //         console.error('Error creating RequiredService Type:', data.message);
            //     }
            // } catch (error) {
            //     console.error('Network error:', error);
            // }
            // finally {
            //     setIsSubmitting(false); // Stop the spinner
            // }
        },
    });
    const [editshow, setEditShow] = useState(false);
    const handleEditClose = () => setEditShow(false);
    const handleEditShow = () => setEditShow(true);
    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Charge Name", dataIndex: "Name", key: "Name" },
        { title: "Charge Type", dataIndex: "Type", key: "Type" },
        { title: "Charge Group", dataIndex: "Group", key: "Group" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];

    const dataSource = [{
        key: "1", // Add a unique key for each row
        SNo: "1", // Changed to camelCase
        Name: "John",
        Type: "AE",
        Group: "ddsvd",
        action: (
            <div className="dropdown table-action">
                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                    <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                    <div className="dropdown-item cursor-pointer" to="#" >
                        <i className="fas fa-trash text-blue me-2"></i> Delete
                    </div>
                </div>
            </div>
        )
    }]

    const BillOpt = [
        { value: 'aizobel', label: 'Aizobel / INAZ' },
        { value: 'bagdogra', label: 'Bagdogra / INBD' },
        { value: 'akola', label: 'Akola / INAL' },
        { value: 'amritsar', label: 'Amritsar / INAR' }
    ]

    const BillToOpt = [
        { value: 'aizobel', label: 'Aizobel / INAZ' },
        { value: 'bagdogra', label: 'Bagdogra / INBD' },
        { value: 'akola', label: 'Akola / INAL' },
        { value: 'amritsar', label: 'Amritsar / INAR' }
    ]



    return (
        <Offcanvas className="" show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Add Default Charge</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form >
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">

                                    Importer <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select

                                        className='custom-selector'
                                        options={BillOpt}
                                    // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />

                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">

                                    Consignor <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select

                                        className='custom-selector'
                                        options={BillOpt}
                                    // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-2 ">
                                <div className="mb-1 ">
                                    {/* <input type="checkbox" className="form-check-input" id="exampleCheck1" /> */}
                                    <label className="form-label mb-0" htmlFor="exampleCheck1">
                                        Relation
                                    </label>
                                </div>

                                <div className='w-100 d-flex justify-content-start align-items-center gap-1'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="SCAC"
                                        name="SCAC"

                                    />
                                    {/* <label className="form-label mb-0" >
                                        Days
                                    </label> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-2 ">
                                <div className="mb-1 ">
                                    {/* <input type="checkbox" className="form-check-input" id="exampleCheck1" /> */}
                                    <label className="form-label mb-0" htmlFor="exampleCheck1">
                                        Base
                                    </label>
                                </div>

                                <div className='w-100 d-flex justify-content-start align-items-center gap-1'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="SCAC"
                                        name="SCAC"

                                    />
                                    {/* <label className="form-label mb-0" >
                                        Days
                                    </label> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-2 ">
                                <div className="mb-1 ">
                                    {/* <input type="checkbox" className="form-check-input" id="exampleCheck1" /> */}
                                    <label className="form-label mb-0" htmlFor="exampleCheck1">
                                        Condition
                                    </label>
                                </div>

                                <div className='w-100 d-flex justify-content-start align-items-center gap-1'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="SCAC"
                                        name="SCAC"

                                    />
                                    {/* <label className="form-label mb-0" >
                                        Days
                                    </label> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Valuation Method <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select

                                        className='custom-selector'
                                        options={BillToOpt}
                                    // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Bond Type <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select

                                        className='custom-selector'
                                        options={BillOpt}
                                    // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />

                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="mb-2 ">
                                <div className="mb-1 ">
                                    {/* <input type="checkbox" className="form-check-input" id="exampleCheck1" /> */}
                                    <label className="form-label mb-0" htmlFor="exampleCheck1">
                                        Bond No
                                    </label>
                                </div>

                                <div className='w-100 d-flex justify-content-start align-items-center gap-1'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="SCAC"
                                        name="SCAC"

                                    />
                                    {/* <label className="form-label mb-0" >
                                        Days
                                    </label> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Registration Port <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select

                                        className='custom-selector'
                                        options={BillOpt}
                                    // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />

                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="card">
                        <div className="card-header">
                            <div className="mb-0 form-check ">
                                <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                <label className="form-label mb-0" htmlFor="exampleCheck1">
                                    SVB Loading
                                </label>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">

                                <div className="col-md-12">
                                    <div className="mb-2 ">
                                        <div className="mb-1 ">
                                            {/* <input type="checkbox" className="form-check-input" id="exampleCheck1" /> */}
                                            <label className="form-label mb-0" htmlFor="exampleCheck1">
                                                SVB Ref No.
                                            </label>
                                        </div>

                                        <div className='w-100 d-flex justify-content-start align-items-center gap-1'>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm w-100"
                                                id="SCAC"
                                                name="SCAC"

                                            />
                                            <input
                                                type="date"
                                                className="form-control form-control-sm w-100"
                                                id="SCAC"
                                                name="SCAC"

                                            />
                                            {/* <label className="form-label mb-0" >
                                        Days
                                    </label> */}
                                        </div>
                                    </div>
                                </div>



                                <div className="col-md-6">
                                    <div className="mb-2 ">
                                        <label htmlFor="name" className="form-label ">

                                            Custom House <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <div className='w-100'>
                                            <Select

                                                className='custom-selector'
                                                options={BillOpt}
                                            // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />

                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="mb-2 ">
                                        <label htmlFor="name" className="form-label ">

                                            Loading On <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <div className='w-100'>
                                            <Select

                                                className='custom-selector'
                                                options={BillOpt}
                                            // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-2 ">
                                        <div className="mb-1 ">
                                            {/* <input type="checkbox" className="form-check-input" id="exampleCheck1" /> */}
                                            <label className="form-label mb-0" htmlFor="exampleCheck1">
                                                Rate(Assbl.)
                                            </label>
                                        </div>

                                        <div className='w-100 d-flex justify-content-start align-items-center gap-1'>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm w-100"
                                                id="SCAC"
                                                name="SCAC"
                                                defaultValue="0.00"

                                            />
                                            <label className="form-label mb-0" >
                                                %
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-2 ">
                                        <label htmlFor="name" className="form-label ">

                                            Status <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <div className='w-100'>
                                            <Select

                                                className='custom-selector'
                                                options={BillOpt}
                                            // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-2 ">
                                        <div className="mb-1 ">
                                            {/* <input type="checkbox" className="form-check-input" id="exampleCheck1" /> */}
                                            <label className="form-label mb-0" htmlFor="exampleCheck1">
                                                Rate(Duty)

                                            </label>
                                        </div>

                                        <div className='w-100 d-flex justify-content-start align-items-center gap-1'>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm w-100"
                                                id="SCAC"
                                                name="SCAC"
                                                defaultValue="0.00"
                                            />
                                            <label className="form-label mb-0" >
                                                %
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-2 ">
                                        <label htmlFor="name" className="form-label ">
                                            Status <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <div className='w-100'>
                                            <Select

                                                className='custom-selector'
                                                options={BillToOpt}
                                            // value={BillOpt.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end gap-2 mt-2">
                        {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
                        <button className="btn btn-primary text-xs" type="submit" onClick={handleClose}>
                            Update
                        </button>

                        <button className="btn btn-light text-xs" type="submit" onClick={handleClose}>
                            Cancel
                        </button>
                    </div>

                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default AddMaster